import React from "react";
import Breadcrumbs from "../Breadcrumbs/Breadcrumbs";
import "./Legal.css";

const PrivacyPolicy = () => {
  return (
    <div>
      <Breadcrumbs title="Datenschutzrichtlinie (Privacy Policy)" />
      <div className="container py-16">
        <div className="legal-content">
          <h2>Datenschutzerklärung</h2>
          <p>
            Ihre Privatsphäre ist uns wichtig. Es ist unsere Richtlinie, Ihre
            Privatsphäre in Bezug auf alle Informationen zu respektieren, die
            wir von Ihnen über unsere Website, &copy; digitale zahnpraxis dr.alshoutaiui, und andere von
            uns betriebene Websites sammeln.
          </p>
          <h3>Erhebung von Informationen</h3>
          <p>
            Wir bitten nur dann um persönliche Informationen, wenn wir sie
            wirklich benötigen, um Ihnen einen Dienst zu erbringen. Wir sammeln
            diese Informationen auf faire und rechtmäßige Weise mit Ihrem
            Wissen und Ihrer Zustimmung. Wir teilen Ihnen auch mit, warum wir
            sie sammeln und wie sie verwendet werden.
          </p>
          <h3>Verwendung von Informationen</h3>
          <p>
            Wir bewahren gesammelte Informationen nur so lange auf, wie es
            notwendig ist, um Ihnen den gewünschten Dienst zu erbringen. Die
            Daten, die wir speichern, schützen wir innerhalb
            wirtschaftlich akzeptabler Mittel vor Verlust und Diebstahl sowie
            vor unbefugtem Zugriff, Offenlegung, Kopieren, Nutzung oder
            Veränderung.
          </p>
          <h3>Ihre Rechte</h3>
          <p>
            Sie können unsere Anfrage nach Ihren persönlichen Informationen
            ablehnen, mit dem Verständnis, dass wir Ihnen dann möglicherweise
            einige der gewünschten Dienste nicht zur Verfügung stellen können.
          </p>
          <h3>Kontaktieren Sie uns</h3>
          <p>
            Wenn Sie Fragen dazu haben, wie wir Nutzerdaten und persönliche
            Informationen handhaben, zögern Sie nicht, uns zu kontaktieren.
          </p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
